import React from 'react'
import { Translations } from '../api/language'

export default React.createContext<Translations>({
    culture: '',
    resources: {},
})
